export const supportedLanguages = [
  "en",
  "ja",
  "ko",
  "fr",
  "de",
  "es",
  "zh-TW",
  "zh-CN",
] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const namespaces = [
  "common",
  "navigation",
  "auth",
  "chat",
  "billing",
  "pricing",
  "account",
  "settings",
  "prompts",
  "tools",
  "team",
  "support",
] as const;
export type AppNamespace = (typeof namespaces)[number];

export const defaultNamespace: AppNamespace = "common";
export const initialNamespaces = [
  "common",
  "navigation",
  "auth",
  "chat",
  "tools",
] as const satisfies readonly AppNamespace[];
export const fallbackLanguage: SupportedLanguage = "en";
export const languageStorageKey = "legal-agent.language";
